module.exports = __webpack_public_path__ + "img/image-rieltor.a34a308d.jpg";